class ListingComponent extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.sectionId;
    this.cache = [];

    this.appendNext = false;

    this.initialSearchParams = window.location.search.slice(1);
    this.currentSearchParams = window.location.search.slice(1);

    this.hasFilters = false;

    this.forms = this.querySelectorAll('listing-form form');

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    this.forms.forEach((form) => {
      form.addEventListener('input', this.debouncedOnSubmit.bind(this));

      if (form.id == 'FiltersForm') {
        this.hasFilters = true;
      }
    });

    window.addEventListener('popstate', (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : this.initialSearchParams;

      if (searchParams === this.currentSearchParams) return;

      this.renderPage(searchParams, null, false);
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const forms = [];

    this.forms.forEach((form) => {
      forms.push(this.createSearchParams(form));
    });

    this.renderPage(forms.join('&'), event);
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    const priceRangeEntries = Array.from(formData.entries()).filter(([key]) =>
      key.startsWith('price_range')
    );

    if (priceRangeEntries.length > 0) {
      var priceMin = 99999999;
      var priceMax = 0;

      priceRangeEntries.forEach(([key, value]) => {
        const [min, max] = value.split('-');

        if (min < priceMin) {
          priceMin = min;
        }

        if (max > priceMax) {
          priceMax = max;
        }
      });

      formData.append(`filter.v.price.gte`, (priceMin / 100).toFixed(2));

      formData.append(`filter.v.price.lte`, (priceMax / 100).toFixed(2));

      formData.delete('price_range');
    }

    return new URLSearchParams(formData).toString();
  }

  renderPage(searchParams, event, updateURLHash = true) {
    this.currentSearchParams = searchParams;

    this.classList.add('loading');

    const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`;

    this.cache.some((element) => element.url === url)
      ? this.renderSectionFromCache(url, event)
      : this.renderSectionFromFetch(url, event);

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;

        this.buildPage(url, html, event);
      });
  }

  renderSectionFromCache(url, event) {
    const html = this.cache.find((element) => element.url === url).html;

    this.buildPage(url, html, event);
  }

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    );
  }

  buildPage(url, html, event) {
    this.cache.push({ html, url });

    if (this.hasFilters) {
      this.buildFilters(html, event);
    }

    this.buildProducts(html, event);

    this.classList.remove('loading');
  }

  buildFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const filterFromFetch = parsedHTML.querySelector('#FiltersForm');
    const filterFromDom = document.querySelector('#FiltersForm');

    const detailsFromFetch = parsedHTML.querySelectorAll(
      '#FiltersForm details'
    );
    const detailsFromDom = document.querySelectorAll('#FiltersForm details');

    var openDetails = [];
    var closedDetails = [];

    detailsFromDom.forEach((detail) => {
      if (detail.open) {
        openDetails.push(detail.id);
      } else {
        closedDetails.push(detail.id);
      }
    });

    detailsFromFetch.forEach((detail) => {
      if (openDetails.indexOf(detail.id) > -1) {
        detail.open = true;
      } else {
        detail.open = false;
      }
    });

    filterFromDom.innerHTML = filterFromFetch.innerHTML;

    /*
     * Purlisse redesign (G1.17 FAIL fix, Alex 2026-07-29).
     *
     * 1) RESULTS COUNT was stale after filtering. It lives OUTSIDE #FiltersForm
     *    (rendered as a sibling of the <details> in G1.13 so it sits in the
     *    Filter row, not inside the drawer), so the innerHTML swap above never
     *    touched it. Copy it across from the fetched markup.
     */
    const countFromFetch = parsedHTML.querySelector('.filters__count');
    const countFromDom = document.querySelector('.filters__count');
    if (countFromFetch && countFromDom) {
      countFromDom.textContent = countFromFetch.textContent;
    }

    /*
     * 2) PRICE SLIDER reset to 0/100% after every filter change. The swap above
     *    replaces the slider node, discarding the inline `left` styles, and the
     *    `data-priceReady` guard then stopped it re-initialising — so the
     *    handles snapped to the extremes while the inputs still held values.
     *    Re-run the initialiser against the fresh markup; it re-paints from the
     *    input values, which the fetched HTML preserves.
     */
    if (typeof window.purlisseInitPriceSlider === 'function') {
      window.purlisseInitPriceSlider(filterFromDom);
    }

    if (event) {
      const selectedInput = document.querySelector(`#${event.target.id}`);

      if (selectedInput) {
        selectedInput.focus();
      }
    }
  }

  buildProducts(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    if (this.appendNext) {
      const listingItems = parsedHTML.querySelectorAll(
        '#ProductGrid .listing__item'
      );

      const gridContainer = document.getElementById('ProductGrid');

      listingItems.forEach((item) => {
        gridContainer.appendChild(item);
      });

      document.getElementById('Pagination').innerHTML =
        parsedHTML.getElementById('Pagination').innerHTML;
    } else {
      document.getElementById('ProductGridContainer').innerHTML =
        parsedHTML.getElementById('ProductGridContainer').innerHTML;

      document
        .getElementById('ProductGridContainer')
        .querySelectorAll('.scroll-trigger')
        .forEach((element) => {
          element.classList.remove('scroll-trigger');
          element.classList.remove('animate--slide-in');
        });
    }

    this.appendNext = false;
  }

  setAppendNext(value) {
    this.appendNext = value;
  }
}

customElements.define('listing-component', ListingComponent);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '')
      minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class LoadMore extends HTMLElement {
  constructor() {
    super();

    this.params = this.dataset.params;

    this.listing = this.closest('listing-component');

    this.button = this.querySelector('.pagination__more');

    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.listing.setAppendNext(true);
    this.listing.renderPage(this.params, null, false);
  }
}

customElements.define('load-more', LoadMore);

/*
 * Purlisse redesign (G1.14): "Show more" for long filter value lists.
 *
 * The design caps a group at 7 visible checkboxes and reveals the rest behind
 * an underlined "Show more" link. Progressive enhancement: the markup renders
 * every value, and this script collapses the list on load — so with JS off all
 * values stay visible and usable rather than being permanently hidden.
 *
 * Delegated + re-applied on the theme's section-render event, because the
 * filter markup is replaced wholesale whenever a facet changes.
 */
(function () {
  var COLLAPSE_AT = 7;

  function initShowMore(root) {
    (root || document).querySelectorAll('[data-filter-show-more]').forEach(function (btn) {
      var panel = btn.closest('.mobile-facets__submenu') || btn.parentElement;
      var list = panel && panel.querySelector('.filters__list');
      if (!list || list.dataset.showMoreReady === 'true') return;
      if (list.children.length <= COLLAPSE_AT) {
        btn.hidden = true;
        return;
      }
      list.dataset.collapsed = 'true';
      list.dataset.showMoreReady = 'true';
      btn.hidden = false;
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-filter-show-more]');
    if (!btn) return;
    event.preventDefault();
    var panel = btn.closest('.mobile-facets__submenu') || btn.parentElement;
    var list = panel && panel.querySelector('.filters__list');
    if (!list) return;
    var collapsed = list.dataset.collapsed === 'true';
    list.dataset.collapsed = collapsed ? 'false' : 'true';
    btn.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
    btn.textContent = collapsed ? 'Show less' : 'Show more';
  });

  document.addEventListener('DOMContentLoaded', function () { initShowMore(document); });
  if (document.readyState !== 'loading') initShowMore(document);
  document.addEventListener('shopify:section:load', function (e) { initShowMore(e.target); });

  // The theme replaces the filter markup wholesale after each facet change.
  // Observe ONLY the filters container (not the whole document) so this does
  // not fire on every unrelated DOM mutation on the page.
  function observeFilters() {
    var host = document.querySelector('.filters__container') ||
               document.querySelector('.filters__wrapper');
    if (!host || host.dataset.showMoreObserved === 'true') return;
    host.dataset.showMoreObserved = 'true';
    new MutationObserver(function () { initShowMore(host); })
      .observe(host, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', observeFilters);
  if (document.readyState !== 'loading') observeFilters();
})();

/*
 * Purlisse redesign (G1.14): on DESKTOP the filters are a PERSISTENT SIDEBAR
 * beside the product grid; below 750px they stay the drawer the theme ships.
 *
 * The filter form is rendered ONCE inside the drawer markup. Rather than
 * duplicating it (which would put two sets of inputs with identical names on
 * the page and break the facet form), the existing panel NODE is moved into
 * .listing__sidebar at desktop widths and moved back into the drawer below the
 * breakpoint. Listeners and form state survive because the node itself moves.
 */
(function () {
  var MQ = window.matchMedia('(min-width: 750px)');

  function panel() { return document.querySelector('#Facets-Drawer .drawer__content'); }
  function sidebar() { return document.querySelector('[data-listing-sidebar]'); }
  function drawerHome() { return document.querySelector('#Facets-Drawer .drawer__container'); }

  function place() {
    var p = panel() || document.querySelector('[data-filters-panel]');
    var side = sidebar();
    if (!p || !side) return;

    if (MQ.matches) {
      if (p.parentElement !== side) {
        p.setAttribute('data-filters-panel', '');
        side.appendChild(p);
      }
      // the drawer must never be "open" while the panel lives in the sidebar
      var d = document.querySelector('#FacetsDetails');
      if (d) d.open = false;
    } else {
      var home = drawerHome();
      if (home && p.parentElement !== home) home.appendChild(p);
    }
  }

  document.addEventListener('DOMContentLoaded', place);
  if (document.readyState !== 'loading') place();
  if (MQ.addEventListener) MQ.addEventListener('change', place);
  else if (MQ.addListener) MQ.addListener(place);
  // facet changes re-render the filter markup
  document.addEventListener('shopify:section:load', place);
  var host = document.querySelector('.filters__container');
  if (host) new MutationObserver(place).observe(host, { childList: true, subtree: true });
})();

/*
 * Purlisse redesign (G1.15): dual-handle price slider.
 *
 * Keeps the two handles in sync with the min/max number inputs above and
 * submits the same filter.v.price.gte / .lte params, so there is ONE source of
 * truth for the price facet. Pointer events cover mouse/touch/pen in one path;
 * arrow keys move a handle for keyboard users (the handles carry role="slider"
 * and aria-valuenow, updated as they move).
 *
 * The handles cannot cross: min is clamped to max and vice versa.
 */
(function () {
  function initPriceSlider(root) {
    (root || document).querySelectorAll('[data-price-slider]').forEach(function (slider) {
      if (slider.dataset.priceReady === 'true') return;
      slider.dataset.priceReady = 'true';

      var li = slider.closest('.filters__price');
      var inputs = li ? li.querySelectorAll('.filters__price-input') : [];
      var minInput = inputs[0], maxInput = inputs[1];
      var handleMin = slider.querySelector('[data-price-handle="min"]');
      var handleMax = slider.querySelector('[data-price-handle="max"]');
      var rangeEl = slider.querySelector('[data-price-range]');
      if (!handleMin || !handleMax || !minInput || !maxInput) return;

      var LO = parseFloat(slider.dataset.priceMin) || 0;
      var HI = parseFloat(slider.dataset.priceMax) || 0;
      if (!(HI > LO)) return;

      function readVals() {
        var a = parseFloat(minInput.value);
        var b = parseFloat(maxInput.value);
        if (isNaN(a)) a = LO;
        if (isNaN(b)) b = HI;
        a = Math.min(Math.max(a, LO), HI);
        b = Math.min(Math.max(b, LO), HI);
        if (a > b) a = b;
        return [a, b];
      }

      function paint() {
        var v = readVals();
        var pMin = ((v[0] - LO) / (HI - LO)) * 100;
        var pMax = ((v[1] - LO) / (HI - LO)) * 100;
        // Keep each handle INSIDE the span: shift it by its own width in
        // proportion to how far along the track it sits (0% at the left edge,
        // 100% at the right). Prevents the 9px overhang at both extremes.
        handleMin.style.left = pMin + '%';
        handleMin.style.setProperty('--handle-shift', pMin);
        handleMax.style.left = pMax + '%';
        handleMax.style.setProperty('--handle-shift', pMax);
        handleMin.setAttribute('aria-valuenow', String(v[0]));
        handleMax.setAttribute('aria-valuenow', String(v[1]));
        if (rangeEl) {
          rangeEl.style.left = pMin + '%';
          rangeEl.style.width = Math.max(0, pMax - pMin) + '%';
        }
      }

      // submit through the theme's own facet form so filtering behaves
      // exactly as it does for the checkboxes
      function commit() {
        var form = slider.closest('form');
        if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
      }

      function valueFromClientX(clientX) {
        var box = slider.getBoundingClientRect();
        var usable = box.width - 18; // half a handle at each end
        var ratio = (clientX - box.left - 9) / (usable || 1);
        ratio = Math.min(Math.max(ratio, 0), 1);
        return Math.round(LO + ratio * (HI - LO));
      }

      function drag(handle, isMin) {
        handle.addEventListener('pointerdown', function (e) {
          e.preventDefault();
          handle.setPointerCapture(e.pointerId);

          function move(ev) {
            var val = valueFromClientX(ev.clientX);
            var v = readVals();
            if (isMin) minInput.value = Math.min(val, v[1]);
            else maxInput.value = Math.max(val, v[0]);
            paint();
          }
          function up(ev) {
            try { handle.releasePointerCapture(ev.pointerId); } catch (err) {}
            handle.removeEventListener('pointermove', move);
            handle.removeEventListener('pointerup', up);
            handle.removeEventListener('pointercancel', up);
            commit();
          }
          handle.addEventListener('pointermove', move);
          handle.addEventListener('pointerup', up);
          handle.addEventListener('pointercancel', up);
        });

        handle.addEventListener('keydown', function (e) {
          var step = (e.key === 'PageUp' || e.key === 'PageDown') ? 10 : 1;
          var dir = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'PageUp') dir = 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown' || e.key === 'PageDown') dir = -1;
          if (e.key === 'Home') dir = -Infinity;
          if (e.key === 'End') dir = Infinity;
          if (!dir) return;
          e.preventDefault();
          var v = readVals();
          if (isMin) {
            var nv = dir === -Infinity ? LO : dir === Infinity ? v[1] : v[0] + dir * step;
            minInput.value = Math.min(Math.max(nv, LO), v[1]);
          } else {
            var nx = dir === -Infinity ? v[0] : dir === Infinity ? HI : v[1] + dir * step;
            maxInput.value = Math.min(Math.max(nx, v[0]), HI);
          }
          paint();
          commit();
        });
      }

      drag(handleMin, true);
      drag(handleMax, false);
      // typing in the inputs moves the handles
      minInput.addEventListener('input', paint);
      maxInput.addEventListener('input', paint);
      paint();
    });
  }

  /*
   * Exposed so buildFilters() can re-initialise after the facet form is
   * replaced wholesale (the swap discards the slider node and its inline
   * positions). Re-painting from the input values is what restores the
   * handles — the fetched markup preserves those values.
   */
  window.purlisseInitPriceSlider = initPriceSlider;

  document.addEventListener('DOMContentLoaded', function () { initPriceSlider(document); });
  if (document.readyState !== 'loading') initPriceSlider(document);
  document.addEventListener('shopify:section:load', function (e) { initPriceSlider(e.target); });
  var host = document.querySelector('.filters__container');
  if (host) new MutationObserver(function () { initPriceSlider(document); })
    .observe(host, { childList: true, subtree: true });
})();
